import { render, staticRenderFns } from "./CustomerPackageDashboard.vue?vue&type=template&id=bf67c596&scoped=true&"
import script from "./CustomerPackageDashboard.vue?vue&type=script&lang=ts&"
export * from "./CustomerPackageDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerPackageDashboard.vue?vue&type=style&index=0&id=bf67c596&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf67c596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBadge,VBtn,VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VDivider,VRow,VSkeletonLoader})
